
import { Sale, SaleHistory } from "@/models/base";
import Vue from "vue";
import AppSaleHistoryEvent from "./SaleHistoryEvent.vue";
import { formatDistanceToNow, isSameDate } from "@/utils/date-utils";
import { printLocalDate } from "@/utils/pretty-print";
import AppSaleHistoryEventReminderSentInfo from "./SaleHistoryEventReminderSentInfo.vue";
import AppSaleHistoryEventSentInfo from "./SaleHistoryEventSentInfo.vue";
import AppSaleHistoryEventEmailRead from "./SaleHistoryEventEmailRead.vue";
import AppSaleHistoryEventSigned from "./SaleHistoryEventSigned.vue";
import AppSaleHistoryEventPeppolInvoiceResponseReceived from "./SaleHistoryEventPeppolInvoiceResponseReceived.vue";
import { AuthService, DossierService } from "@/services";

export default Vue.extend({
	data(){
		return {
			openedExtraInfoEvent: null as null | SaleHistory
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		createdDateString():string{
			if (isSameDate(this.sale.TimeCreated, new Date())){
				return formatDistanceToNow(this.sale.TimeCreated);
			}
			return printLocalDate(this.sale.TimeCreated);
		},
		extraInfoComponentName():string{
			if (!this.openedExtraInfoEvent) {
				return "";
			}
			return `app-sale-history-event-${this.openedExtraInfoEvent.getExtraInfoComponentName()}`;
		},
		historyItems():SaleHistory[] {
			let history = [...this.sale.History];
			let bankHistory:SaleHistory[] = this.sale.Banks.map(b=>{
				return SaleHistory.fromBank(b, this.sale);
			});
			history.push(...bankHistory);
			history.sort((a,b)=>{
				return b.TimeStamp.getTime() - a.TimeStamp.getTime();
			});
			return history;
		},
		creatorName():string {
			if (this.sale.CreatorID == 0) return this.$ct("by-user", {user: AuthService.wfUser.getShortDisplayName()}).toString();
			let name = DossierService.getUser(this.sale.CreatorID).getShortDisplayName();
			return this.$ct("by-user", {user: name}).toString();
		}
	},
	components: {
		AppSaleHistoryEvent,
		AppSaleHistoryEventReminderSentInfo,
		AppSaleHistoryEventSentInfo,
		AppSaleHistoryEventEmailRead,
		AppSaleHistoryEventSigned,
		AppSaleHistoryEventPeppolInvoiceResponseReceived,
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
